<template>
  <div class="input-main" :style="{ height: textType == 'imageUpload' ? imgHeight : '25px' }">
    <div v-if="textType == 'text' || textType == 'password' || textType == 'number'" class="placeholder" :style="{ justifyContent: placeholderAlign, top: placeholderTop, fontSize: placeholderFont,
      opacity: placeholderTop == '-12px' ? 1 : 0.6 }">
      <span v-if="isRequired" style="color: red; margin-right: 5px">**</span> {{ placeholder }}
    </div>

    <input v-if="textType == 'text' || textType == 'password' || textType == 'number'" :type="textType" :style="{ textAlign: textAlign, padding: placeholder ? '14px 10px 9px 10px' : '7px 10px' }" :disabled="isDisabled"
      @keyup="inputKeyUp" @keydown="inputKeydown" @focus="focusIn()" @blur="focusOut()" @input="inputChanged" ref="myinput" v-model="pInputValue">

    <div v-if="textType == 'file'" class="file-area">
      <div v-if="isDisabled" class="file-disabled"></div>
      <div class="upload-area">
        <span v-if="isRequired" style="color: red; margin-right: 5px">**</span>
        <button style="margin: 0; padding: 3px 8px; width: fit-content; white-space: nowrap">{{ placeholder }}</button>
        <div style="width: auto; margin-left: 3px" class="truncate-text">{{ fileDescription }}</div>
        
        <div v-if="pSelectedFiles" class="hover-icon">
          <img style="margin-left: 5px" src="https://dsmapi.logistics.systems/dsm6gIcons/icons8-info-64.png" height="20"
            @mouseover="showAllFileNames = true" @mouseleave="showAllFileNames = false">
          <div v-if="showAllFileNames" class="hover-arrow"></div>
          <div v-if="showAllFileNames" class="hover-popup">
            <div style="margin-bottom: 5px">{{ Array.from(pSelectedFiles).length }} files</div>
            <div v-for="(f, i) in Array.from(pSelectedFiles)" :key="i">{{ i + 1 }}.   {{ f.name }}</div>
          </div>
        </div>

        <div v-if="pSelectedFiles" class="hover-icon">
          <img style="margin-left: 5px" src="https://dsmapi.logistics.systems/dsm6gIcons/icons8-close-90.png" height="20"
            @mouseover="showClearFilesTitle = true" @mouseleave="showClearFilesTitle = false" @click="clearAttachmentClicked">
          <div v-if="showClearFilesTitle" class="hover-arrow"></div>
          <div v-if="showClearFilesTitle" class="hover-popup">
            Clear all selected files
          </div>
        </div>
      </div>
      <div v-if="fileOver" class="file-drop">
        Drop Here
      </div>
      <input type="file" class="file-input" @change="fileChanged" :multiple="multiFile" title=""
        @dragover="fileOver = true" @drop="fileOver = false" @dragleave="fileOver = false" ref="fileInput">
    </div>

    <div v-if="textType == 'imageUpload'" class="img-upload" :style="{ height: imgHeight, width: imgWidth }">
      <img v-if="imgSelected" :src="`data:image/jpeg;base64, ${imgSelected}`">
      <div v-if="!imgSelected && !fileOver" class="no-picture">
        <div v-if="isDisabled">No {{ placeholder }} found</div>
        <div v-else>Drag or click to select your {{ placeholder }}</div>
      </div>
      <div v-if="fileOver" class="drop-border" :style="{ border: isDisabled ? '2px dashed red' : '2px dashed green'}">
        <div v-if="isDisabled">{{ placeholder }} cannot be changed</div>
        <div v-else>Drop your<br>{{ placeholder }}</div>
      </div>
      <input type="file" @change="imageUpload" ref="imgUpload" accept="image/*" :disabled="isDisabled"
        @dragover="fileOver = true" @drop="fileOver = false" @dragleave="fileOver = false" :title="placeholder">
      <div v-if="imgSelected && !isDisabled" class="clear-image" @click="clearImage()">❌</div>
      <div v-if="isRequired" class="image-upload-required">
        **
        <div v-if="pErrorMessage" :style="{ top: '0px', left: '18px', margin: '0px 3px' }" @click="focusIn('focus')">
          <div class="error-message">
            {{ pErrorMessage }}
          </div>
        </div>
      </div>
    </div>
      
    <div v-if="pErrorMessage && (textType != 'imageUpload')" class="error-box" :style="{ justifyContent: errorAlign }" @click="focusIn('focus')">
      <div class="error-message">
        {{ pErrorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data: function() {
    return {
      placeholderTop: '-1px',
      placeholderFont: '12px',
      pInputValue: '',
      fileDescription: 'No file selected',
      placeholderAlign: 'flex-start',
      errorAlign: '',
      showError: false,
      pErrorMessage: null,

      pSelectedFiles: null,
      showAllFileNames: false,
      showClearFilesTitle: false
    }
  },
  props: {
    imgClass: { type: String, default: "" },
    mainClass: { type: String, default: "main" },

    fileOver: { type: Boolean, default: false },

    //public
    placeholder: { type: String, default: "Placeholder" }, // Set the placeholder of the input
    textAlign: { type: String, default: "" }, // Set this to left, center or right
    textType: { type: String, default: "text" }, // Change this to password if the input is password
    inputValue: { type: String, default: "" }, // Bind this value to get the input value
    isDisabled: { type: Boolean, default: false }, // Set this to true to disable any user input
    errorMessage: { type: String, default: null }, // Set the error message (BETA)
    isRequired: { type: Boolean, default: false }, // Set this to true to indicate this input is required
    borderWidth: { type: String, default: '0 0 1px 0' }, // Change the border width to the desired border 'top right bottom left'

    fileType: { type: String, default: '' }, // The filetype accepted for textType file
    multiFile: { type: Boolean, default: false }, // Set to true to allow selecting multi files from the input
    // selectedFiles: { type: Array, default: function() { return [] } }, // The array of the selected files

    imgSelected: { type: String, default: '' }, // The base64 of the image selected (textType = imageUpload)
    imgType: { type: String, default: '' }, // The type/extension of the image (textType = imageUpload)
    imgWidth: { type: String, default: '200px' }, // The width of the image (textType = imageUpload)
    imgHeight: { type: String, default: '200px' }, // The height of the image (textType = imageUpload)
    hasDecimal: { type: Boolean, default: true }, // Set this to false if you don't allow . or decimal place in your input (for textType number only!)

    // public events
    // @focusIn - fired when the input is focused
    // @focusOut - fired when the input is focused out
    // @enter - fired when 'Enter' key is pressed within the input
    // @down - fired when 'ArrowDown' key is pressed within the input (BETA)
    // @fileChanged - return the array of the files selected along with the placeholder
    // @fileChangedFor - return the placeholder of the changed files to indicate which component trigger the fileChanged event
    // @inputChanged - when the value in the input is changed
  },
  methods: {
    focusIn: function(e) {
      if (this.pErrorMessage) {
        this.pErrorMessage = null;
        this.$emit('update:errorMessage', this.pErrorMessage);
      }

      if (e) {
        this.$refs.myinput.focus();
      }
      this.$emit('focusIn', this);

      this.placeholderTop = '-12px';
      this.placeholderFont = '8px';
    },
    focusOut: function() {
      this.$emit('focusOut');

      if (!this.pInputValue) {
        this.placeholderTop = '-1px';
        this.placeholderFont = '12px';
      }
    },
    eyeClickIn: function() {
      if (this.textType == "password") {
        this.textType = "text";
      } else {
        this.textType = "password";
      }
    },
    inputKeyUp: function(key) {
      if (key.key == 'Enter') {
        this.$emit('enter', '');
      }

      if (key.key == 'ArrowDown') {
        this.$emit('down');
      }
    },
    inputKeydown: function(key) {
      this.$emit('keyDown', key);

      if (this.textType == 'number') {
        if (key.key == 'ArrowUp' || key.key == 'ArrowDown') {
          key.preventDefault();
        } else if (key.key == 'e') {
          key.preventDefault();
        } else if (key.key == '.') {
          if (!this.hasDecimal) {
            key.preventDefault();
          }
        }
      }
    },
    inputChanged: function(e) {
      var currentText = this.pInputValue;

      if (this.isDisabled) {
        return;
      }

      this.$emit('update:inputValue', this.pInputValue);
      this.$emit('inputChanged', e)
    },
    setFocus: function() {
      this.$refs.myinput.focus();
    },
    fileChanged: function(e) {
      if (e.target.files.length > 0) {
        this.pSelectedFiles = e.target.files;
        this.$emit('fileChanged', e.target.files, this.placeholder);
        if (e.target.files.length == 1) {
          this.fileDescription = e.target.files[0].name;
        } else {
          this.fileDescription = `${e.target.files.length} files selected`;
        }
      } else if (!this.pSelectedFiles) {
        this.$emit('fileChanged', e.target.files, this.placeholder);
        this.fileDescription = 'No file selected';
      }
    },
    clearAttachmentClicked: function() {
      this.$emit('fileChanged', null, this.placeholder);
      this.fileDescription = 'No file selected';
      this.pSelectedFiles = null;
      this.showAllFileNames = false;
      this.showClearFilesTitle = false;
    },
    imageUpload: function(e) {
      var reader = new FileReader();
      reader.readAsBinaryString(e.target.files[0]);
      this.imgType = e.target.files[0].type;
      this.$emit('update:imgType', this.imgType);
      
      reader.onload = r => {
        this.imgSelected = btoa(r.target.result);
        this.$emit('update:imgSelected', this.imgSelected);
        this.pErrorMessage = null;
      }
    },
    clearImage: function() {
      var input = this.$refs.imgUpload;
      input.type = 'text';
      input.type = 'file';

      this.imgSelected = '';
      this.$emit('update:imgSelected', this.imgSelected);

      this.imgType = '';
      this.$emit('update:imgType', this.imgType);
    },
  },
  watch: {
    errorMessage: function(val) {
      this.pErrorMessage = val;
      if (val) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    },
    textAlign: function(val) {
      switch (val) {
        case 'left':
          this.placeholderAlign = 'flex-start';
          break;
        case 'center':
          this.placeholderAlign = 'center';
          break;
        case 'right':
          this.placeholderAlign = 'flex-end';
          break;
      }
    },
    inputValue: function(val) {
      this.pInputValue = val;
      if (val) {
        this.placeholderTop = '-12px';
        this.placeholderFont = '8px';
      } else {
        this.placeholderTop = '-1px';
        this.placeholderFont = '12px';
      }
    }
  },
  mounted() {
    switch (this.textAlign) {
      case 'left':
        this.placeholderAlign = 'flex-start';
        this.errorAlign = 'flex-start';
        break;
      case 'center':
        this.placeholderAlign = 'center';
        this.errorAlign = 'center';
        break;
      case 'right':
        this.placeholderAlign = 'flex-end';
        this.errorAlign = 'flex-end';
        break;
    }
    
    if (this.inputValue) {
      this.pInputValue = this.inputValue;
      this.placeholderTop = '-12px';
      this.placeholderFont = '8px';
    }

    if (this.errorMessage) {
      this.pErrorMessage = this.errorMessage;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/css/all.scss";

.input-main {
  width: 100%;
  position: relative;
  height: 25px;
  padding: 0;
  display: flex;
  margin: 2px 0px;
  // background-color: green;
}

.placeholder {
  position: absolute;
  display: flex;
  // background-color: red;
  height: 100%;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  align-items: center;
  transition: 0.3s;
  opacity: 0.6;
}

input[type=text], input[type=password], input[type=number] {
  width: 100%;
  height: 20px;
  border-width: 0 0 1px 0;
  border-style: solid;
  border-color: rgba(128,128,128,0.5);
  background-color: transparent;
  position: relative;
  font-size: 12px;
  transition: $transition-time;
  top: -3px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

input:disabled {
  opacity: 0.8;
  background-color: rgba(200,200,200,0.3);
}

input:focus {
  outline: none;
  border-color: black;
}

.error-box {
  position: absolute;
  width: 100%;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: text;
  font-size: 12px;
  top: -3px;
}

.error-message {
  background-color: red;
  color: white;
  padding: 1px 5px;
  border-radius: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.error-message:hover {
  overflow: visible;
  z-index: 111;
  border: 1px solid black;
}

// Normal file upload
.file-area {
  font-size: 12px;
  position: relative;
  width: 100%;
  // overflow: hidden;

  > .file-disabled {
    background-color: rgba(200,200,200,0.3);
    z-index: 99;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .file-input {
    cursor: pointer;
    opacity: 0;
    width: 100%;
    position: absolute;
    top: 0;
  }

  .file-input::-webkit-file-upload-button {
    background-color: $btn-color;
    transition: $transition-time;
    padding: 5px 10px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
  }

  .file-input::-webkit-file-upload-button:hover {
    background-color: $btn-color-hover;
  }

  .file-input::-webkit-file-upload-button:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0,0,0,0.3);
  }

  .upload-area {
    position: relative;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;

    > .hover-icon {
      position: relative;
      display: flex;
      align-items: center;
      z-index: 1;
      /* background: red; */

      > .hover-popup {
        position: absolute;
        background: rgba(64,64,64,1);
        width: max-content;
        left: 0;
        top: calc(100% + 5px);
        padding: 5px;
        color: white;
      }

      > .hover-arrow {
        border-color: transparent transparent rgb(64,64,64) transparent;
        border-width: 5px;
        border-style: solid;
        position: absolute;
        top: calc(100% - 5px);
        left: 7px;
      }
    }
  }

  .file-drop {
    display: flex;
    align-items: center;
    font-weight: bolder;
    background-color: white;
    border: 1px solid black;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    padding-left: 5px;
  }
}
// Normal file upload

// Image file upload
.img-upload {
	border: 1px solid black;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .drop-border {
    position: absolute;
    transform: scale(0.98);
    font-weight: bolder;
    background-color: white;
  }

  .no-picture, .drop-border {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .clear-image {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }

  .image-upload-required {
    display: flex;
    color: red;
    position: absolute;
    top: 5px;
    left: 5px;
  }

	input {
		position: absolute;
		top: 0;
		left: 0;
		background-color: red;
		height: 100%;
		width: 100%;
    opacity: 0;
    cursor: pointer;
  }
  
  input:disabled {
    cursor: unset;
  }

	img {
		position: absolute;
		max-height: 100%;
		max-width: 100%;
  }
}
// Image file upload
</style>